/**
 * Configure the switch between the compilation environment and the online environment
 *
 * baseUrl: Domain name address
 * routerMode: Routing mode
 * imgBaseUrl: Domain name and address of the picture
 *
 */
let BASE_URL = process.env.VUE_APP_API_BASE;
// let ROUTER_MODE = "history";
let ROUTER_MODE = "";
let IMG_BASE_URL = BASE_URL;
export { BASE_URL, ROUTER_MODE, IMG_BASE_URL };